<div style="position: relative">
  <video
    #videoPlayer
    [width]="videoSize.width"
    [height]="videoSize.height"
    autoplay="true"
  ></video>
  <button
    *ngIf="showManualTrigger"
    class="icon-capture"
    (click)="onManualTrigger()"
    >Captura Manual</button
  >
</div>
